import React from 'react';
import { Icon } from '@ab-inbev-maz/compass';
import type { IconName } from '@ab-inbev-maz/compass/dist/entities/components/icon.js';

interface EmptyTableProps {
  message?: string;
  description?: React.ReactNode;
  icon?: IconName;
}

/**
 * Componente que muestra un mensaje cuando una tabla está vacía
 */
const EmptyTable: React.FC<EmptyTableProps> = ({
  message = 'No hay datos disponibles',
  description = <>Lo sentimos, no hemos encontrado resultados.<br />Te sugerimos probar con otros parámetros de búsqueda.</>,
  icon = 'validation/alert-octagon'
}) => {
  return (
    <div className="w-full py-10 flex flex-col items-center justify-center">
      <div className="mb-4">
        <Icon name={icon} />
      </div>
      <p className="text-gray-500 text-lg font-medium">{message}</p>
      <p className="text-gray-400 text-sm mt-2 text-center">{description}</p>
    </div>
  );
};

export default EmptyTable;
